module.exports = __webpack_public_path__ + "static/cover-bc39c0374e7aded19685c93cbf33649f.webm";